import { Clipboard } from '@angular/cdk/clipboard';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import * as moment from 'moment';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';

@Component({
  selector: 'app-edit-api-setting',
  templateUrl: './edit-api-setting.component.html',
  styleUrls: ['./edit-api-setting.component.scss'],
})
export class EditApiSettingComponent implements OnInit {
  editApi_settingform: UntypedFormGroup;
  isClientSecretVisible: boolean = true;
  isClientIdVisible: boolean = true;
  view_page: boolean = false;
  breadcrumbList = [
    {
      label: 'API-settings',
      url: '/baseapp/profile/api-settings'
    },
    {
      label: 'Update',
      url: '',

    }
  ];

  api_types = ['API', 'Websocket', 'Webhook-websocket'];
  valid_duration = [{ name: '1 year', value: 1 }, { name: '2 years', value: 2 }, { name: '3 years', value: 3 }];
  secret_expiry = '';
  client_id: any;
  client_id_copied:boolean=false;
  client_secret_copied:boolean=false;
  client_secret_password:string='';
  client_id_password:string='';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private storage: Storage,
    private backendService: BackendService,
    private route: ActivatedRoute,
    private helperService: HelperService,
    private router : Router,
    private clipBoard : Clipboard
  ) {
    route.paramMap.subscribe((data: any) => {
      this.client_id = parseInt(data.params.id);
    })
    route.url.subscribe((data)=>{
      if(data[0].path.includes('api-details')){
        this.view_page = true;
        this.breadcrumbList[1].label='Details'
      }
    })
  }

  ngOnInit() {
    this.editApi_settingform = this.formBuilder.group({
      'name': ['', [Validators.required]],
      'type': ['', [Validators.required]],
      'secret_expiry': [[], [Validators.required]],
      'description': ['', Validators.required],
      'client_id': ['', Validators.required],
      'client_secret': ['', Validators.required]
    });
    this.getStorage().then((res) => {
      this.helperService.loader();
      let params = new HttpParams().set('id', this.client_id)
      this.backendService.GetAPICall('viewClientDetails', res.token, params).subscribe((data) => {
        this.helperService.closeLoader().then(() => {
          this.editApi_settingform.get('name').patchValue(data.name);
          this.editApi_settingform.get('type').patchValue(data.type);
          this.editApi_settingform.get('description').patchValue(data.description);
          this.editApi_settingform.get('secret_expiry').patchValue(Math.abs(new Date(data.secret_expiry).getFullYear() - new Date().getFullYear()));
          this.editApi_settingform.get('client_id').patchValue(data.client_id);
          this.editApi_settingform.get('client_secret').patchValue(data.client_secret);
          this.client_secret_password='•'.repeat(this.editApi_settingform.get('client_secret').value.length);
          this.client_id_password='•'.repeat(this.editApi_settingform.get('client_id').value.length);
          this.secret_expiry = data.secret_expiry;
          if(this.view_page){
            this.editApi_settingform.get('name').disable();
            this.editApi_settingform.get('type').disable();
            this.editApi_settingform.get('description').disable();
            this.editApi_settingform.get('secret_expiry').disable();
            this.editApi_settingform.get('client_id').disable();
            this.editApi_settingform.get('client_secret').disable();
          }
        })
      },
      (error)=>{
        this.helperService.handleError(error);
      }
    )
    })
    document.getElementById('client_secret').addEventListener('click',this.autoresize)
    const textarea = document.getElementById('client_secret') as HTMLTextAreaElement;
    textarea.addEventListener('focusout',()=>{
          textarea.style.height = 56 + 'px';
        })
    document.getElementById('client-id').addEventListener('click',this.autoresizeID)
    const client_id = document.getElementById('client-id') as HTMLTextAreaElement;
    client_id.addEventListener('focusout',()=>{
          client_id.style.height = 56 + 'px';
        })
  }

  autoresizeID(event){
    const secret_div = document.getElementById('client-id') as HTMLTextAreaElement;
    secret_div.style.height = 'auto';
    secret_div.style.height = secret_div.scrollHeight + 'px !important';
  }

  autoresize(event){
    const secret_div = document.getElementById('client_secret') as HTMLTextAreaElement;
    secret_div.style.height = 'auto';
    secret_div.style.height = secret_div.scrollHeight + 'px !important';
  }


  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
    }
    return data;
  }

  createClientSecret(){
    this.getStorage().then((res)=>{
      this.backendService.PostAPICall('refreshClientSecret', {}, res.token).subscribe((data)=>{
        this.editApi_settingform.get('client_secret').patchValue(data.client_secret);
        this.client_secret_password='•'.repeat(data.client_secret.length);
      },
      (error)=>{
        this.helperService.handleError(error);
      }
    )
    })
  }

  updateClientSecret() {
    if (!this.editApi_settingform.invalid) {
      let payload = this.editApi_settingform.value;
      payload.is_active = 1;
      payload.secret_expiry = moment().add(this.editApi_settingform.value.secret_expiry, 'year').format('YYYY-MM-DDTHH:mm:ss');
      payload.id = this.client_id;
      this.getStorage().then((res) => {
        this.backendService.PutAPICall('updateClientDetails', payload, res.token).subscribe((data: any) => {
          this.router.navigate(['/baseapp/profile/api-settings'])
          this.helperService.presentToast(data.msg, 2000);
        },
        (error)=>{
          this.router.navigate(['/baseapp/profile/api-settings'])
          this.helperService.handleError(error);
        }
      )
      })
    }
    else {
      this.helperService.presentToast("Please fill all the required fields", 2000);
    }
  }

  copyContent(content,source) {
    this.clipBoard.copy(content);
    source=='client_id'?this.client_id_copied=true:this.client_secret_copied=true;
    setTimeout(()=>{
      this.client_id_copied=false;
      this.client_secret_copied=false;
    },1500);
  }

}
